<template>
  <div>
    <div class="p-grid p-justify-start p-mb-3">
      <Button
        style="position: relative; top: 10px; left: 10px;"
        class="dsButton"
        v-tooltip.right="'Back to Dashboard'"
        @click="goRouter('/')"
      >
        <font-awesome-icon style="color: white" icon="arrow-left" :label="$t('back')"></font-awesome-icon>&nbsp;
        <font-awesome-icon class="menuIcon" :icon="['fal', 'home-alt']" />
      </Button>
    </div>
    <div class="p-grid p-justify-center">
      <div class="p-col">
        <div class="box" v-if="busy">
          <h1 class="title is-2">{{ $t("loader") }}</h1>
          <div>
            <ProgressSpinner />
          </div>
        </div>
        <div v-else class="box">
          <div class="p-field p-col-12 p-col-md-6">
            <div
              v-if="currentUser && currentUser.upgraded"
              style="max-width: 400px; margin: 0 auto; line-height: 1.5em"
            >
              <h1 class="title is-2">
                <font-awesome-icon
                  class="menuIcon"
                  style="color: green; font-size: 2em"
                  :icon="['fal', 'check-circle']"
                />
              </h1>
              <h1 class="title is-2">{{ $t("Billing.upgrade_ttile") }}</h1>
              <p>{{ $t("Billing.thank_you") }}</p>
              <div class="p-mt-5">
                <Button @click="startBilling" class="dsButton bigButton" :label="$t('Billing.open_portal')" />
              </div>
            </div>
            <div v-else class="p-text-left">
              <h1 class="title is-2">{{ $t("Billing.upgrade_account.title") }}</h1>
              <p>
                {{ $t("Billing.upgrade_account.text") }}
              </p>
              <br />
              <p>{{ $t("Billing.upgrade_now") }}</p>
              <br />
              <div class="pricing">
                <div class="pricing__plans" v-if="this.$i18n.locale === 'ja'">
                  <div
                    v-for="plan in jpPlans"
                    :key="plan.name"
                    class="pricing__plan"
                    :class="{ 'pricing__plan--popular': plan.popular }"
                  >
                    <div class="pricing__plan__body">
                      <div class="pricing__plan__info">
                        <div v-if="plan.popular" class="pricing__plan__for-whom">
                          一番人気
                        </div>
                        <div v-else>
                          <br>
                        </div>
                        <div class="pricing__plan__descriptions">
                          <div class="pricing__plan__name">
                            {{ plan.name }}
                          </div>
                          <div class="pricing__plan__description">
                            {{ plan.description }}
                          </div>
                        </div>
                      </div>
                      <Button v-if="plan.custom" class="pricing__plan__btn pricing__plan__btn" @click="contactUs">お問い合わせ</Button>
                      <Button v-else class="pricing__plan__btn pricing__plan__btn" @click="startCheckout(plan.slug)">アップグレードする</Button>
                      <div class="pricing__plan__features">
                        <div v-if="plan.common" class="pricing__plan__features__label">
                          {{ plan.common }}
                        </div>
                        <div v-else class="pricing__plan__features__label">
                          プラン内容
                        </div>
                        <div class="pricing__plan__features__list">
                          <div v-for="feature in plan.features" :key="feature">
                            <div class="pricing__plan__features__item">
                              <font-awesome-icon
                                class="menuIcon"
                                style="color: black; margin: 3px 0px;"
                                :icon="['fal', 'check-circle']"
                              />
                              {{ feature.feature }}
                            </div>
                            <div v-if="feature.sub_features" class="pricing__plan__features__sub-items">
                              <div
                                v-for="subFeature in feature.sub_features"
                                :key="subFeature"
                                class="pricing__plan__features__sub-item"
                              >
                                {{ subFeature }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="pricing__plan__footer">
                      <Button v-if="plan.custom" class="pricing__plan__btn pricing__plan__btn" @click="contactUs"> お問い合わせ</Button>
                      <div v-else class="pricing__plan__footer">
                        <div style="width: 250.67px">
                          <span class="pricing__plan__price-text">¥</span>
                          <span class="pricing__plan__monthly-price">{{ plan.price }}</span>
                          /月
                        </div>
                        <div class="pricing__plan__annual-price">年間¥{{ plan.annual_price }}</div>
                        <Button @click="startCheckout(plan.slug)" class="pricing__plan__btn">アップグレードする</Button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pricing__plans" v-else>
                  <div
                    v-for="plan in plans"
                    :key="plan.name"
                    class="pricing__plan"
                    :class="{ 'pricing__plan--popular': plan.popular }"
                  >
                    <div class="pricing__plan__body">
                      <div class="pricing__plan__info">
                        <div v-if="plan.popular" class="pricing__plan__for-whom">
                          Most Popular
                        </div>
                        <div v-else>
                          <br>
                        </div>
                        <div class="pricing__plan__descriptions">
                          <div class="pricing__plan__name">
                            {{ plan.name }}
                          </div>
                          <div class="pricing__plan__description">
                            {{ plan.description }}
                          </div>
                        </div>
                      </div>
                      <Button v-if="plan.custom" class="pricing__plan__btn pricing__plan__btn" @click="contactUs">Contact Us</Button>
                      <Button v-else class="pricing__plan__btn pricing__plan__btn" @click="startCheckout(plan.slug)">Upgrade Now</Button>
                      <div class="pricing__plan__features">
                        <div v-if="plan.common" class="pricing__plan__features__label">
                          {{ plan.common }}
                        </div>
                        <div v-else class="pricing__plan__features__label">
                          Includes
                        </div>
                        <div class="pricing__plan__features__list">
                          <div v-for="feature in plan.features" :key="feature">
                            <div class="pricing__plan__features__item">
                              <font-awesome-icon
                                class="menuIcon"
                                style="color: black; margin: 3px 0px;"
                                :icon="['fal', 'check-circle']"
                              />
                              {{ feature.feature }}
                            </div>
                            <div v-if="feature.sub_features" class="pricing__plan__features__sub-items">
                              <div
                                v-for="subFeature in feature.sub_features"
                                :key="subFeature"
                                class="pricing__plan__features__sub-item"
                              >
                                {{ subFeature }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="pricing__plan__footer">
                      <Button v-if="plan.custom" class="pricing__plan__btn pricing__plan__btn" @click="contactUs">Contact Us</Button>
                      <div v-else class="pricing__plan__footer">
                        <div style="width: 250.67px">
                          <span class="pricing__plan__price-text">$</span>
                          <span class="pricing__plan__monthly-price">{{ plan.price }}</span>
                          per month
                        </div>
                        <div class="pricing__plan__annual-price">billed annually</div>
                        <Button @click="startCheckout(plan.slug)" class="pricing__plan__btn">Upgrade Now</Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {},
  data() {
    return {
      busy: false,
      jpPlans: [
        {
          name: "プロ",
          slug: "jp_pro_yearly",
          price: "2,980",
          annual_price: "35,760",
          description: "シンプルなスケジューリングにフォーカスしたスケジューラー向け",
          popular: false,
          features: [
            {
              feature: "無制限のシーズン",
            },
            {
              feature: "トーナメント＆プレーオフ",
            },
            {
              feature: "無制限のリーグ、ディビジョン、チーム（ディビジョンあたり50チームまで）",
            },
            {
              feature: "メール、電話、Zoomサポート",
            },
            {
              feature: "CSVのインポートとエクスポート",
            },
            {
              feature: "スケジューリングパワーツール",
              sub_features: [
                "会場優先度",
                "会場、時間、曜日のバランス",
                "週末と平日のバランス（週末メソッド）",
                "チームの移動制約",
                "チームの時間制約",
              ],
            },
          ],
        },
        {
          name: "オールスター",
          slug: "jp_all_star_yearly",
          price: "4,980",
          annual_price: "59,760",
          description: "スケジューリングとリーグ管理を行うリーグマネージャー向け（チーム、コーチ、保護者向けのコミュニティ管理ツールを含む）",
          popular: true,
          common: "プロに加えて",
          features: [
            {
              feature: "公開ウェブページ",
              sub_features: ["スケジュール", "スコア", "順位表", "ロースター", "プレイヤーランキング（近日公開）"],
            },
            {
              feature: "リーグ管理ポータル",
              sub_features: [
                "保護者とチームのメッセージング",
                "登録と支払い処理（1回限りまたは定期購入）",
                "チケット販売",
                "イベント管理",
                "プライベート＆パブリックコミュニティ管理",
              ],
            },
          ],
        },
        {
          name: "カスタム",
          slug: "jp_custom_yearly",
          price: false,
          custom: true,
          description: "スケジューリングのヘルプとカスタムリーグ管理ソリューションを探しているリーグ向け",
          popular: false,
          common: "オールスターに加えて",
          features: [
            {
              feature: "スケジューリングコンサルティング（専任スケジューラーがリーグのスケジュールを作成するのをお手伝いします！）"
            },
            {
              feature: "カスタマイズされたリーグウェブサイト（ホームページ、ロゴ、プレイヤー登録）"
            },
            {
              feature: "優先サポート",
            },
          ],
        },
      ],
      plans: [
        {
          name: "Pro",
          slug: "pro_yearly",
          price: 19.99,
          annual_price: 239.88,
          description: "For schedulers focused on simple scheduling.",
          popular: false,
          features: [
            {
              feature: "Unlimited Seasons",
            },
            {
              feature: "Tournaments & Playoffs",
            },
            {
              feature: "Unlimited Leagues, Divisions, and Teams (capped at 50 teams/division)",
            },
            {
              feature: "Email, Phone & Zoom Support",
            },
            {
              feature: "CSV imports & exports",
            },
            {
              feature: "Scheduling Power Tools",
              sub_features: [
                "Venue Prioritization",
                "Venue, Time and Day Balancing",
                "Weekend and Weekday Balancing (weekend method)",
                "Team Travel Constraints",
                "Team Time Constraints",
              ],
            },
          ],
        },
        {
          name: "All-Star",
          slug: "all_star_yearly",
          price: 24.99,
          annual_price: 299.88,
          description: "For schedulers and league managers looking to schedule and manage their leagues (includes community management tooling for team, coaches, and parents).",
          popular: true,
          common: "Everything in Pro and",
          features: [
            {
              feature: "Public Webpage",
              sub_features: ["Schedules", "Scores", "Standings", "Rosters", "Player Rankings (coming soon)"],
            },
            {
              feature: "League Management Portal",
              sub_features: [
                "Parent and Team Messaging",
                "Registration and Payment Processing including 1-time or subscription",
                "Ticketing",
                "Event Management",
                "Private & Public community management",
              ],
            },
          ],
        },
        {
          name: "Elite",
          slug: "elite_yearly",
          price: 49.99,
          annual_price: 599.88,
          description: "For advanced schedulers looking for high powered scheduling tooling.",
          popular: false,
          common: "Everything in All-Star and",
          features: [
            {
              feature: "Advanced Scheduling Tools (Desktop App with advanced scheduling algorithms)",
              sub_features: [
                ">50 teams per division",
                "Multiple Pairing Algorithm",
                "Double Header Scheduling (back-to-back)",
                "Minimize Wait Times Between Games",
                "Keep Coaches at Same Venue Collection",
                "Prioritize Early/Late Timeslots First",
              ],
            },
            {
              feature: "DirectLink with RAMP Interactive, League Athletics, SportsEngine, Squad Fusion, Team Snap",
            },
            {
              feature: "Premium Support",
            },
          ],
        },
        {
          name: "Custom",
          slug: "custom_yearly",
          price: false,
          custom: true,
          description: "For leagues looking for scheduling help and custom league management solutions.",
          popular: false,
          common: "Everything in Elite and",
          features: [
            {
              feature: "Scheduling Consultation (Dedicated Scheduler to help you schedule your league!)"
            },
            {
              feature: "Customized League Website (Home page, Logos, Player Registration)"
            },
            {
              feature: "Priority Support",
            },
          ],
        },
      ],
    };
  },
  methods: {
    startBilling() {
      this.busy = true;
      this.trackEvent("Opened Billing Portal", {
        user: this.currentUser,
        organization: this.$store.getters.currentOrganization,
      });
      api
        .stripeBilling()
        .then(response => {
          console.log(response);
          window.location.href = response.data.url;
        })
        .catch(e => {
          console.log(e);
          this.busy = false;
        });
    },
    startCheckout(plan) {
      this.trackEvent("Started Checkout", {
        user: this.currentUser,
        organization: this.$store.getters.currentOrganization,
      });
      this.busy = true;
      api
        .stripeCheckout(plan)
        .then(response => {
          console.log(response);
          console.log(this.stripe);
          this.stripe.redirectToCheckout({ sessionId: response.data.id });
        })
        .catch(e => {
          console.log(e);
          this.busy = false;
        });
    },
    contactUs() {
      // open mailto
      if (this.$i18n.locale === 'ja') {
        window.location.href = "mailto:support@diamondscheduler.jp";
      } else {
      window.location.href = "mailto:hello@cactusware.com";
      }
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.goRouter("/sign-in?return=/billing");
    }
    this.$store.dispatch("getLeagueInformation");
    if (this.$i18n.locale === 'ja') {
      this.stripe = Stripe(
        process.env.VUE_APP_STRIPE_PK_JP ||
          "pk_test_51IZjm4A1sbNE5hfu6I4xDJf06PaU5pXfyFnXEcq9TebgdfG4YBrSGTOGSdC1guMVtaTwnxmUyvox8pFrZmJsRDjV008qb3PiWb",
      );
    } else {
      this.stripe = Stripe(
        process.env.VUE_APP_STRIPE_PK ||
          "pk_test_51IZjm4A1sbNE5hfu6I4xDJf06PaU5pXfyFnXEcq9TebgdfG4YBrSGTOGSdC1guMVtaTwnxmUyvox8pFrZmJsRDjV008qb3PiWb",
      );
    }
    window.analytics.page();
    this.trackEvent("Viewed Billing", {
      user: this.currentUser,
    });
  },
};
</script>

<style scoped lang="scss">
ul {
  list-style: circle;
  width: 200px;
  margin: 0 auto;
}
</style>
